export function assertNever(
    n: never,
    message = `Non-exhaustive conditional detected for ${JSON.stringify(n)}`,
): never {
    throw new Error(message)
}
